"use strict";
/*
 * Created on 11 28 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var SimpleExportedEntityPublicConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SimpleExportedEntityPublicConverter, _DataObjectConverter_);

  function SimpleExportedEntityPublicConverter() {
    _classCallCheck(this, SimpleExportedEntityPublicConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimpleExportedEntityPublicConverter).apply(this, arguments));
  }

  return SimpleExportedEntityPublicConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SimpleExportedEntityPublicConverter = SimpleExportedEntityPublicConverter;